import { DefaultOptionType } from 'antd/lib/select';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import ISelectorProps from '../../interfaces/ISelectorProps';
import AuthContext from '../../../../app/contexts/auth';
import TenantsService from '../../../../common/services/tenants/tenants.service';
import SelectAutocomplete from '../../../../common/components/select-autocomplete';

function CountrySelector({
    selectedPreferences,
    setSelectedPreferences,
}: Readonly<ISelectorProps>) {
    const { t } = useTranslation();
    const { user } = AuthContext.useAuth();

    const [countriesOptions, setCountriesOptions] = useState<
        DefaultOptionType[] | null
    >(null);

    const getOptions = useCallback(async () => {
        const tenants = await TenantsService.getTenantsListAsync();

        const options: DefaultOptionType[] = tenants.map(item => {
            return {
                value: item.key,
                label: item.description,
            };
        });

        setCountriesOptions(options);
    }, []);

    useEffect(() => {
        if (countriesOptions === null) getOptions();
    }, [countriesOptions, getOptions]);

    return (
        <SelectAutocomplete
            label={t('OperationCountry')}
            placeholder={t('OperationCountry')}
            defaultValue={user?.country}
            options={countriesOptions ?? []}
            onChange={value =>
                setSelectedPreferences({
                    ...selectedPreferences,
                    country: value,
                })
            }
            data-testid="user-country-select"
        />
    );
}

export default CountrySelector;
